<template>
  <vue-form :form="form" @submit="submit">
    <form-group field="username" label="Pseudo">
      <vue-input id="username" v-model="form.username" :disabled="loading"/>
    </form-group>
    <form-group field="password" label="Mot de passe">
      <vue-input type="password" id="password" v-model="form.password" :disabled="loading"/>
    </form-group>
    <div class="text-center mt-4">
      <vue-button type="submit" class="btn btn-primary w-full md:w-auto" :disabled="loading">Se connecter</vue-button>
    </div>
  </vue-form>
</template>

<script>
/* globals route */

import Form from 'form-backend-validation';
import ErrorHandler from '../../core/ErrorHandler';
import FormGroup from '../FormGroup.vue';

export default {
  components: { FormGroup },

  data() {
    return {
      loading: false,
      form: new Form({
        username: '',
        password: '',
        remember: true,
      }),
    };
  },

  methods: {
    submit() {
      this.loading = true;
      this.form
        .post(route('login'))
        .then(() => window.location.assign(route('dashboard')))
        .catch((error) => {
          this.loading = false;
          new ErrorHandler(error).dispatch();
        });
    },
  },
};
</script>